<template>
  <div>
    <social-header v-if='currentEnv' title="提现"></social-header>
    <div v-if="withdrawInfo.totalMoney > 0" class="withdrawSettlement">
      <ul class="navbar">
        <li class="nav-item" v-show="withdrawInfo.bankMoney > 0" @click="changeType('bank')">
          提现至银行卡
           <div class="line1" v-show="type === 'bank' && withdrawInfo.bankMoney > 0"></div>
        </li>
        <li class="nav-item" v-show="withdrawInfo.walletMoney > 0" @click="changeType('carPay')">
          提现至汽车之家钱包
          <div class="line2" v-show="type === 'carPay' && withdrawInfo.walletMoney > 0 "></div>
        </li>
      </ul>
      <div class="bank-wrap" v-show="type === 'bank' && withdrawInfo.bankMoney > 0">
        <div class="bank-name">{{bankInfo.bankFullName?bankInfo.bankFullName:''}}({{bankInfo.cardNo?bankInfo.cardNo.slice(-4):''}})</div>
        <div class="bank-info">{{bankInfo.custName?bankInfo.custName:''}}<span class="line"></span>{{bankInfo.identityNo?bankInfo.identityNo:''}}</div>
        <div class="triangle"></div>
      </div>
      <div class="withdraw-money">
        <div class="withdraw-amount">
          <p>可提现金额(元)</p>
          <div class="money">￥{{withdrawMoney}}</div>
        </div>
        <div class="withdraw-explain">
          <p>到账时效说明：预计1-3个工作日到账</p>
          <p>提现金额说明：目前仅支持全部提现，暂不支持部分提现</p>
        </div>
      </div>
      <div class="withdraw-btn" :class="{'opciaty': !withdrawMoney}" @click.self='preExtract'>提现</div>
      <!-- <div class="withdraw-btn opacity">提现</div> -->
      <div class="withdraw-qbtx" @click="toWallet">汽车之家钱包提现&nbsp;<i class="iconfont_M icon-more_M"></i></div>
      <social-dialog title="正在加载" category="tips" v-bind:show="dialogShow"></social-dialog>
    </div>
    <Empty v-else/>
  </div>
</template>
<script>
import Empty from '../../components/empty.vue'
import SocialHeader from '../../components/social-header.vue'
import { isWeiXin, isDingDing, changeDocumentTitle } from '../../service/environment'
import userApi from '../../api/user'
import SocialDialog from '../../components/social-dialog.vue'
export default {
  name: 'WithdrawSettlement',
  components: {
    SocialHeader,
    Empty,
    SocialDialog
  },
  data: function () {
    return {
      dialogShow: false,
      type: '',
      isRealName: false,
      isExtractTipsShow: false,
      bankInfo: {},
      withdrawInfo: {}
    }
  },
  computed: {
    currentEnv () {
      if (isWeiXin()) {
        return false
      } else if (isDingDing()) {
        return false
      } else {
        return true
      }
    },
    withdrawMoney () {
      if (this.withdrawInfo.bankMoney > 0 && this.type === 'bank') {
        return this.withdrawInfo.bankMoney
      } else if (this.withdrawInfo.walletMoney > 0 && this.type === 'carPay') {
        return this.withdrawInfo.walletMoney
      } else {
        return 0
      }
    },
    userINFO () {
      return JSON.parse(localStorage.getItem('USER_INFO'))
    }
  },
  methods: {
    changeType (value) {
      if (value === 'bank') {
        this.type = value
        this.bgImage = this.image1
      } else if (value === 'carPay') {
        this.type = value
        this.bgImage = this.image2
      }
    },
    // 提现
    async preExtract () {
      var current = this
      if (this.withdrawMoney) {
        if (current.type === 'bank' && current.withdrawInfo.bankMoney > 0) {
          current.dialogShow = true
          let res = await userApi.saveWithdrawMoneyData({PlatformAgentID: current.userINFO.platformAgentID, money: current.withdrawInfo.bankMoney, payType: 1})
          current.dialogShow = false
          if (res.data.returncode === 0) {
            this.$confirm({
              title: '提现成功',
              message: '提现成功，预计1-3个工作日到账，你可在提现记录中查看提现状态。',
              confirmButtonText: '确定',
              onConfirm: () => {
                this.$router.go(-1)
              },
              onclose: () => {
                this.$router.go(-1)
              }
            })
          } else {
            this.$confirm({
              title: '提现失败',
              message: res.data.message,
              confirmButtonText: '确定',
              onConfirm: () => {
                window.location.reload()
              },
              onclose: () => {
                window.location.reload()
              }
            })
          }
        } else if (current.type === 'carPay' && current.withdrawInfo.walletMoney > 0) {
          current.dialogShow = true
          let res = await userApi.saveWithdrawMoneyData({PlatformAgentID: current.userINFO.platformAgentID, money: current.withdrawInfo.walletMoney, payType: 2})
          current.dialogShow = false
          if (res.data.returncode === 0) {
            this.$confirm({
              title: '提现成功',
              message: '提现成功，预计1-3个工作日到账，你可在提现记录中查看提现状态。',
              confirmButtonText: '确定',
              onConfirm: () => {
                this.$router.go(-1)
              },
              onclose: () => {
                this.$router.go(-1)
              }
            })
          } else {
            this.$confirm({
              title: '提现失败',
              message: res.data.message,
              confirmButtonText: '确定',
              onConfirm: () => {
                window.location.reload()
              },
              onclose: () => {
                window.location.reload()
              }
            })
          }
        }
      }
    },
    // 跳转钱包
    toWallet: function () {
      window.location.href = 'https://pay.autohome.com.cn/m/personalwallet/balance'
    },
    async getBankdata () {
      var current = this
      current.dialogShow = true
      let res = await userApi.getBankData({PlatformAgentID: current.userINFO.platformAgentID})
      current.dialogShow = false
      if (res.data.returnCode === 0) {
        current.bankInfo = res.data.result
      }
    },
    async getPayMoneyData () {
      var current = this
      current.dialogShow = true
      let res = await userApi.getPayMoneyData({PlatformAgentID: current.userINFO.platformAgentID})
      current.dialogShow = false
      if (res.data.returnCode === 0) {
        current.withdrawInfo = res.data.result
        if (current.withdrawInfo.bankMoney > 0) {
          current.type = 'bank'
        } else if (current.withdrawInfo.walletMoney > 0) {
          current.type = 'carPay'
        } else if (current.withdrawInfo.walletMoney > 0 && current.withdrawInfo.walletMoney > 0) {
          current.type = 'bank'
        }
      }
    }
  },
  created () {
    changeDocumentTitle('提现')
  },
  beforeMount () {
    if (this.userINFO) {
      this.getBankdata()
      this.getPayMoneyData()
    }
  }
}
</script>
<style  scoped>
  .withdrawSettlement{
    width: 100%;
    height: auto;
    background-image: url('../../static/img/bank-bg.png');
    background-size: 100% 100%;
    position: relative;
  }
  .navbar{
    width: 80%;
    display: flex;
    font-size: .875rem;
    align-items: center;
    position: relative;
    color: #fff;
    font-size: 1rem;
    padding: 1.125rem 0 1.25rem 1.5625rem;
    margin-bottom: .625rem;
  }
  .nav-item {
    width: 9rem;
    height: 1.25rem;
    position: relative;
  }
  .line1{
    width: 1rem;
    height: .5rem;
    background: url('../../static/img/selecting.png');
    background-size: 100% 100%;
    position: absolute;
    left: 2rem;
    bottom: -10px;
  }
  .line2{
    width: 1rem;
    height: .5rem;
    background: url('../../static/img/selecting.png');
    background-size: 100% 100%;
    position: absolute;
    left: 2.5rem;
    bottom: -10px;
  }
  .bank-wrap{
    width: 21.5625rem;
    height: 4.375rem;
    margin: 0 auto;
    margin-bottom: 1.125rem;
    padding: .9375rem;
    font-size: .875rem;
    color: #fff;
    border-radius: .5rem;
    box-sizing: border-box;
    background: rgb(49, 115, 242);
    position: relative;
  }
  .bank-name{
    margin-bottom: .8125rem;
  }
  .line{
    display: inline-block;
    margin: 0 .625rem;
    width: .0625rem;
    height: .625rem;
    border-right: .0625rem solid rgb(109, 159, 255);;
  }
  .triangle{
    width: 0;
    height: 0;
    border-left: .5rem solid transparent;
    border-right: .5rem solid transparent;
    border-bottom: .625rem solid rgb(49, 115, 242);
    position: absolute;
    top: -0.5rem;
    left: 2.8125rem;
  }
  .withdraw-money{
    width: 21.5625rem;
    height: 11.375rem;
    margin: 0 auto;
    border-radius: .5rem;
    box-shadow: 0rem .125rem .5625rem .5rem rgba(84, 121, 255, 0.06);
    background: rgb(255, 255, 255);
    padding: 1.5625rem 1.3125rem;
    box-sizing: border-box;
  }
  .withdraw-money .withdraw-amount{
    border-bottom: .0625rem solid rgb(234, 234, 234);
  }
  .withdraw-money .withdraw-amount p{
    margin-bottom: .9375rem;
  }
  .withdraw-money .withdraw-amount .money{
    font-size: 2.625rem;
    margin-bottom: .5rem;
  }
  .withdraw-explain {
    padding: .9375rem 0;
    font-size: .75rem;
    color: rgb(130, 140, 160);
    line-height: 1.25rem;
  }
  .withdraw-btn{
    width: 19.6875rem;
    height: 2.8125rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background: linear-gradient(180.00deg, rgb(58, 126, 255),rgb(33, 109, 254) 100%);
    position: fixed;
    bottom: 7.875rem;
    left: calc(50% - 9.8438rem);
    border-radius: .25rem;
    z-index: 100;
    margin-bottom: 0.5rem;
  }
  .opacity{
    opacity: 0.5;
  }
  .withdraw-qbtx{
    width: 19.6875rem;
    color: rgb(102, 109, 127);
    position: fixed;
    bottom: 6.0625rem;
    left: calc(50% - 9.8438rem);
    z-index: 100;
    font-size: .875rem;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon-more_M{
    font-size: .6rem;
  }
  .opciaty{
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/withdrawSettlement.vue